import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DetailRowService, GridComponent, SelectionService } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs, TextWrapSettingsModel } from '@syncfusion/ej2-grids';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { ColumnChangeBO } from '../eligibility270/eligibility270.model';
import { WhereCondition } from '../client-parent/client-parent.model';
import { columnWidth } from '../icd10/icd10.model';
import { ApplyFilter271, FilterLogsBo, GetEligibility271, GetEligibilityLogsBo } from './eligibility-logs.modal';
import { CommonApiService } from 'src/app/commonapiservice';
import { Get271Logs } from './eligibility-logs.service';
@Component({
  selector: 'app-eligibility-logs',
  templateUrl: './eligibility-logs.component.html',
  styleUrls: ['./eligibility-logs.component.scss'],
  providers: [DetailRowService, SelectionService]
})
export class EligibilityLogsComponent implements OnInit {
  ErrorDataList: any = [];
  RequestPayload: any = [];
  EligibilityListIds: any = [];
  RequestContent: any = [];
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridEligibilityLogs') public gridEligibilityLogs: GridComponent;
  @ViewChild('gridEligibility271') public gridEligibility271: GridComponent;
  public GridDataList: Observable<DataStateChangeEventArgs>;
  public GridData271: Observable<DataStateChangeEventArgs>;
  EligibilityData: any = [];
  Eligibility271Data : any =[];
  id: string ="00000000-0000-0000-0000-000000000000";
  FilterDates: FilterLogsBo = new FilterLogsBo();
  Filter271 : ApplyFilter271 = new ApplyFilter271();
  type: string = "";
  conditionlist: WhereCondition[] = [];
  arraycol: any = [];
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  public filterSettings: object;
  public formatOptions: Object;
  initialPage: object; ValidationDate: any;
  public wrapSettings: TextWrapSettingsModel;
  ErrorinitialPage: object;
  ColumnsCglogs: columnWidth[];
  eligibilityLogsError : string;
  view271client: boolean = false;

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true,
  };

  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  EligibilityLogsBo: GetEligibilityLogsBo = new GetEligibilityLogsBo();
  Eligibility271Logs : GetEligibility271 = new GetEligibility271();
  constructor( public CommonAPI: CommonApiService, private cdr: ChangeDetectorRef, private datepipe: DatePipe, public toasterService: ToastrService, public dateservice: DateService,  public global: GlobalComponent,
    public Eligibility271 : Get271Logs ,
  ) {
    this.GridDataList = CommonAPI;
    this.GridData271 = Eligibility271;
  }
  ngAfterContentChecked() {

    this.cdr.detectChanges();
  }

 
  ngOnInit(): void {
    
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0 ) {
      return;
    }
    this.formatOptions = { type: 'datetime', format: 'MM/dd/yyyy h:mm:ss a' };
    this.filterSettings = { type: 'Menu' };
    this.ErrorinitialPage = { pageSize: 10 };
    this.wrapSettings = { wrapMode: 'Content' };
    let CGPage = 10
    let page = 10;
    this.initialPage = { currentPage: 1, pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: CGPage };
    this.EligibilityLogsBo.pageitem = CGPage;
    this.Eligibility271Logs.pageitem = CGPage
  }
  //...................................................onActionComplete........................................................
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridEligibilityLogs.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Eligibility_Logs.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].Eligibility_Logs.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].Eligibility_Logs.ShowColumns.length != count1 || this.arraycol[0].Eligibility_Logs.HideColumns.length != count) {
            this.arraycol[0].Eligibility_Logs.ShowColumns = showarr;
            this.arraycol[0].Eligibility_Logs.HideColumns = hidearr;
          }
        }
      }
    }
    this.EligibilityLogsBo.currentpageno = this.gridEligibilityLogs.pagerModule.pagerObj.currentPage;
    this.EligibilityLogsBo.pageitem = this.gridEligibilityLogs.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.EligibilityLogsBo.type = args.columnType
    }


  }
  //................................................... dataStateChange.................................................
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.EligibilityLogsBo.orderColumn = state.sorted[0].name;
        this.EligibilityLogsBo.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.EligibilityLogsBo.field = state.action.currentFilterObject.field;
      this.EligibilityLogsBo.matchCase = state.action.currentFilterObject.matchCase;
      this.EligibilityLogsBo.operator = state.action.currentFilterObject.operator;
      this.EligibilityLogsBo.value = state.action.currentFilterObject.value;
      if (this.EligibilityLogsBo.type == "number") {
        this.EligibilityLogsBo.value = state.action.currentFilterObject.value.toString();
        this.EligibilityLogsBo.field = state.action.currentFilterObject.field;
      }
      else if (this.EligibilityLogsBo.type == "datetime") {
        this.EligibilityLogsBo.value = this.global.getDateTimeString(state.action.currentFilterObject.value);
        this.EligibilityLogsBo.field = state.action.currentFilterObject.field;
      }
      else {
        this.EligibilityLogsBo.value = state.action.currentFilterObject.value;
        this.EligibilityLogsBo.field = state.action.currentFilterObject.field;
      }
      this.EligibilityLogsBo.matchCase = state.action.currentFilterObject.matchCase;
      this.EligibilityLogsBo.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.EligibilityLogsBo.field = "companyName";
        this.EligibilityLogsBo.matchCase = false;
        this.EligibilityLogsBo.operator = "startswith";
        this.EligibilityLogsBo.value = "";
        this.EligibilityLogsBo.type = "string";
      }
    }
    if (this.type != "refresh") {
      this.ApplyFilter();
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Eligibility_Logs.Pagesize != state.take) {
          this.arraycol[0].Eligibility_Logs.Pagesize = state.take
        }

    }
  }
}
  //.............................................onResize.................................................................
  onResize(args) {
    if (this.ColumnsCglogs != undefined && this.ColumnsCglogs != null) {
      const column = this.gridEligibilityLogs.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.gridEligibilityLogs.refreshHeader();
    this.ColumnsCglogs.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }
    });

    }
  }
 //...................................................onActionComplete........................................................
 public onActionComplete271(args) {
  if (args.requestType == "columnstate") {
    let hidearr = [];
    let showarr = [];
    this.gridEligibility271.columns.forEach(element => {
      if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
        hidearr.push(element.headerText);
      }
      if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
        showarr.push(element.headerText);
      }
    })
    var count = 0;
    var count1 = 0;
    if (args.columns.length > 0) {
      if (this.arraycol.length > 0) {
        this.arraycol[0].Eligibility_Logs.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].Eligibility_Logs.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].Eligibility_Logs.ShowColumns.length != count1 || this.arraycol[0].Eligibility_Logs.HideColumns.length != count) {
          this.arraycol[0].Eligibility_Logs.ShowColumns = showarr;
          this.arraycol[0].Eligibility_Logs.HideColumns = hidearr;
        }
      }
    }
  }
  this.Eligibility271Logs.currentpageno = this.gridEligibility271.pagerModule.pagerObj.currentPage;
  this.Eligibility271Logs.pageitem = this.gridEligibility271.pagerModule.pagerObj.pageSize;
  this.conditionlist = [];
  if (args.requestType === "filtering" && args.action === "filter") {
    args.columns.forEach(element => {
      this.conditionlist.push(element.properties);
    });
  }
  if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
    this.Eligibility271Logs.type = args.columnType
  }


}
//................................................... dataStateChange.................................................
public dataStateChange271(state): void {
  this.type = (state.action.requestType).toString();
  if (this.type != "filterchoicerequest") {
    if ((state.sorted || []).length) {
      this.Eligibility271Logs.orderColumn = state.sorted[0].name;
      this.Eligibility271Logs.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
    }
  }
  if (this.type == "filtering" && state.action.action != "clearFilter") {
    this.Eligibility271Logs.field = state.action.currentFilterObject.field;
    this.Eligibility271Logs.matchCase = state.action.currentFilterObject.matchCase;
    this.Eligibility271Logs.operator = state.action.currentFilterObject.operator;
    this.Eligibility271Logs.value = state.action.currentFilterObject.value;
    if (this.Eligibility271Logs.type == "number") {
      this.Eligibility271Logs.value = state.action.currentFilterObject.value.toString();
      this.Eligibility271Logs.field = state.action.currentFilterObject.field;
    }
    else if (this.Eligibility271Logs.type == "datetime") {
      this.Eligibility271Logs.value = this.global.getDateTimeString(state.action.currentFilterObject.value);
      this.Eligibility271Logs.field = state.action.currentFilterObject.field;
    }
    else {
      this.Eligibility271Logs.value = state.action.currentFilterObject.value;
      this.Eligibility271Logs.field = state.action.currentFilterObject.field;
    }
    this.Eligibility271Logs.matchCase = state.action.currentFilterObject.matchCase;
    this.Eligibility271Logs.operator = state.action.currentFilterObject.operator;
  }
  else {
    if (this.type == "filtering" && state.action.action == "clearFilter") {
      this.Eligibility271Logs.field = "companyName";
      this.Eligibility271Logs.matchCase = false;
      this.Eligibility271Logs.operator = "startswith";
      this.Eligibility271Logs.value = "";
      this.Eligibility271Logs.type = "string";
    }
  }
  if (this.type != "refresh") {
    this.ApplyFilter271();
  }
  if (this.type == "paging" && state.action.name == "actionBegin") {
    if (this.arraycol.length != 0) {
      if (this.arraycol[0].Eligibility_Logs.Pagesize != state.take) {
        this.arraycol[0].Eligibility_Logs.Pagesize = state.take
      }

  }
}
}
//.............................................onResize.................................................................
onResize271(args) {
  if (this.ColumnsCglogs != undefined && this.ColumnsCglogs != null) {
    const column = this.gridEligibility271.getColumnByField(args.column.field)
  column.width = args.column.width;
  this.gridEligibility271.refreshHeader();
  this.ColumnsCglogs.forEach(element => {
    if (element.column == column.headerText) {
      element.width = parseInt(column.width.toString());
    }
  });

  }
}
  //..........................................getEligibilityLogsFilter.....................................................
  getEligibilityLogsFilter() {
    let count = 0;
    let url = "api/SFTPDetail/GetSFTP_270Logs"
    let responseData =
    {
      result: "result",
      count: "count",
    }
    this.CommonAPI.outputValues(url, this.EligibilityLogsBo, responseData,"");
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.EligibilityData = data.result;
      count = count + 1;
      if (this.global.globalAgencyId != 0) {
        if (data != null && data != undefined && count == 1) {
        }
      }
      if (this.global.globalAgencyId != 0) {
        if (data != null && data.result.length > 15) {
          this.gridEligibilityLogs.height = '500';
        }
        else {
          this.gridEligibilityLogs.height = 'auto';
        }
      }
    })
  }
  getEligibility271Logs() {
    let count = 0;
    let url = "api/SFTPDetail/GetSFTP_271Logs"
    let responseData =
    {
      result: "result",
      count: "count",
    }
    this.Eligibility271.outputValues(this.Eligibility271Logs);
    this.GridData271.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.Eligibility271Data = data.result;
      count = count + 1;
      if (this.global.globalAgencyId != 0) {
        if (data != null && data != undefined && count == 1) {
        }
      }
      if (this.global.globalAgencyId != 0) {
        if (data != null && data.result.length > 15) {
          this.gridEligibility271.height = '500';
        }
        else {
          this.gridEligibility271.height = 'auto';
        }
      }
    })
  }
  //..................................................showorhidecolumns...........................................
  showorhidecolumns() {
    this.gridEligibilityLogs.openColumnChooser(200, 50);
  }
  showorhidecolumns271() {
    this.gridEligibility271.openColumnChooser(200, 50);
  }
  //..................................................newdates...........................................
  newdates(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'FromDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterDates.FromDate = val1;
        }
      }
      if (name == 'ToDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterDates.ToDate = val1;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'FromDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterDates.FromDate = val1;

          var StartDate = new Date(this.FilterDates.FromDate);
          let setDate = StartDate.setDate(StartDate.getDate() + 365);
          let getDate = setDate;
          this.ValidationDate = this.datepipe.transform(getDate, "MM/dd/yyyy");
          this.clearEndTimeValidation();
        }
      }
      if (name == 'ToDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterDates.ToDate = val1;
          this.clearEndTimeValidation();

        }
      }
    }
  }
  newdates271(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'FromDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.Filter271.FromDate = val1;
        }
      }
      if (name == 'ToDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.Filter271.ToDate = val1;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'FromDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.Filter271.FromDate = val1;

          var StartDate = new Date(this.Filter271.FromDate);
          let setDate = StartDate.setDate(StartDate.getDate() + 365);
          let getDate = setDate;
          this.ValidationDate = this.datepipe.transform(getDate, "MM/dd/yyyy");
          this.clearEndTimeValidation271();
        }
      }
      if (name == 'ToDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.Filter271.ToDate = val1;
          this.clearEndTimeValidation271();

        }
      }
    }

  }
  clearEndTimeValidation() {
    if (this.FilterDates.FromDate != null && this.FilterDates.FromDate != undefined && this.FilterDates.FromDate != '' &&
      this.FilterDates.ToDate != null && this.FilterDates.ToDate != undefined && this.FilterDates.ToDate != '') {
      let EndDate = this.datepipe.transform(this.FilterDates.ToDate, "MM/dd/yyyy");
      if (new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()) {
        this.toasterService.error("Date range should not be greater than 1 year");
        setTimeout(() => {
          this.toasterService.clear();
        }, 3000);
        this.FilterDates.ToDate = null;
      }
      if (this.FilterDates.ToDate != null && this.FilterDates.ToDate != undefined && this.FilterDates.ToDate != '') {
        if (new Date(this.FilterDates.FromDate).getTime() > new Date(this.FilterDates.ToDate).getTime()) {
          this.FilterDates.ToDate = null;
          this.toasterService.error("end time should greater than start time");
          setTimeout(() => {
            this.toasterService.clear();
          }, 3000);
          return;
        }
      }
    }

  }
  clearEndTimeValidation271() {
    if (this.Filter271.FromDate != null && this.Filter271.FromDate != undefined && this.Filter271.FromDate != '' &&
      this.Filter271.ToDate != null && this.Filter271.ToDate != undefined && this.Filter271.ToDate != '') {
      let EndDate = this.datepipe.transform(this.Filter271.ToDate, "MM/dd/yyyy");
      if (new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()) {
        this.toasterService.error("Date range should not be greater than 1 year");
        setTimeout(() => {
          this.toasterService.clear();
        }, 3000);
        this.Filter271.ToDate = null;
      }
      if (this.Filter271.ToDate != null && this.Filter271.ToDate != undefined && this.Filter271.ToDate != '') {
        if (new Date(this.Filter271.FromDate).getTime() > new Date(this.Filter271.ToDate).getTime()) {
          this.Filter271.ToDate = null;
          this.toasterService.error("end time should greater than start time");
          setTimeout(() => {
            this.toasterService.clear();
          }, 3000);
          return;
        }
      }
    }

  }
  //..................................................ApplyFilter...........................................
  ApplyFilter() {

    this.EligibilityLogsBo.edi_Status = this.FilterDates.edi_Status != "" ? this.FilterDates.edi_Status : null;
    this.EligibilityLogsBo.transaction_Status = this.FilterDates.transaction_Status != "" ? this.FilterDates.transaction_Status : null;
    if (this.FilterDates.FromDate == undefined || this.FilterDates.FromDate == "" || this.FilterDates.FromDate == null) {
      this.EligibilityLogsBo.startDate = null;
    }
    else {
      this.EligibilityLogsBo.startDate = this.global.getDateTimeString(this.FilterDates.FromDate);
    }
    if (this.FilterDates.ToDate == undefined || this.FilterDates.ToDate == "" || this.FilterDates.ToDate == null) {
      this.EligibilityLogsBo.endDate = null;
    }
    else {
      this.EligibilityLogsBo.endDate = this.global.getDateTimeString(this.FilterDates.ToDate);
    }
    this.getEligibilityLogsFilter();
  }
  ApplyFilter271(){
    this.Eligibility271Logs.edi_Status = this.Filter271.edi_Status != "" ? this.Filter271.edi_Status : null;
    this.Eligibility271Logs.transaction_Status = this.Filter271.transaction_Status != "" ? this.Filter271.transaction_Status: null;
    if (this.Filter271.FromDate == undefined || this.Filter271.FromDate == "" || this.Filter271.FromDate == null) {
      this.Eligibility271Logs.startDate = null;
    }
    else {
      this.Eligibility271Logs.startDate = this.global.getDateTimeString(this.Filter271.FromDate);
      
    }
    if (this.Filter271.ToDate == undefined || this.Filter271.ToDate == "" || this.Filter271.ToDate == null) {
      this.Eligibility271Logs.endDate = null;
    }
    else {
      this.Eligibility271Logs.endDate = this.global.getDateTimeString(this.Filter271.ToDate);
    }
    this.getEligibility271Logs();
  }

  getError(data){
    this.eligibilityLogsError = data;

  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
